import { loadable } from '@shared/core/loadableFromNamedExport';

// Flag-gated alternate render of PayoutDialog (activeCashFundPartner=mercury). Lazy so couples on the old
// dialog never load the adapter, its GraphQL documents, or the partner catalog.
export const LazyPartnerTransferSheet = loadable(() => import(/* webpackChunkName: "shared/transfer-sheet-adapter" */ './PartnerTransferSheet'), 'PartnerTransferSheet');
